var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5248 1.45191C13.1598 1.23003 13.7698 1.84003 13.5479 2.47503L9.84476 13.0563C9.60413 13.7425 8.64788 13.7813 8.35288 13.1169L6.56601 9.09691L9.08101 6.58128C9.16381 6.49242 9.20888 6.37489 9.20674 6.25346C9.2046 6.13202 9.1554 6.01615 9.06952 5.93027C8.98364 5.84439 8.86777 5.79519 8.74633 5.79305C8.6249 5.7909 8.50737 5.83598 8.41851 5.91878L5.90288 8.43378L1.88288 6.64691C1.21851 6.35128 1.25788 5.39566 1.94351 5.15503L12.5248 1.45191Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendEmail);
export default __webpack_public_path__ + "static/media/send-email.5b1b9666fc655f45fe265083b0ae2717.svg";
export { ForwardRef as ReactComponent };